import { Redirect, Route, Switch } from 'react-router-dom';
import { AppContainer } from 'components/style/Containers.style';
import { AppRow } from 'components/style/Rows.style';
import { Col } from 'reactstrap';
import FooterContainer from './common/Footer/FooterContainer';
import { Helmet } from 'react-helmet';
import Loadable from 'react-loadable';
import LoadingComponent from './common/Loading/LoadingComponent';
import NavigationContainer from './common/Navigation/NavigationContainer';
import NotificationContainer from './common/Notification/NotificationContainer';
import PrivateRoute from './common/PrivateRoute/PrivateRouteContainer';
import PrivateAdminRoute from './common/PrivateAdminRoute/PrivateAdminRouteContainer';
import PropTypes from 'prop-types';
import React from 'react';
import SideMenuContainer from './common/SideMenu/SideMenuContainer';
import OnboardingTour from './common/OnboardingTour/OnboardingTourContainer';

import withAnalytics from 'lib/analytics';

const AsyncHomeContainer = Loadable({
  loader: () => import('./pages/Home/HomeContainer'),
  loading: LoadingComponent
});
const AsyncPlatformUsageContainer = Loadable({
  loader: () => import('./pages/PlatformUsage/PlatformUsageContainer'),
  loading: LoadingComponent
});
const AsyncSHAWContainer = Loadable({
  loader: () => import('./pages/SHAWAnalytics/SHAWAnalyticsContainer'),
  loading: LoadingComponent
});
const AsyncCallCenterContainer = Loadable({
  loader: () => import('./pages/CallCenter/CallCenterContainer'),
  loading: LoadingComponent
});
const AsyncMessagesContainer = Loadable({
  loader: () => import('./pages/Communication/Messages/MessagesContainer'),
  loading: LoadingComponent
});
const AsyncComposeMessageContainer = Loadable({
  loader: () =>
    import('./pages/Communication/ComposeMessage/ComposeMessageContainer'),
  loading: LoadingComponent
});
const AsyncAlertContainer = Loadable({
  loader: () => import('./pages/TravelSecurity/Alerts/AlertContainer'),
  loading: LoadingComponent
});
const AsyncMapContainer = Loadable({
  loader: () => import('./pages/TravelSecurity/MapPage/MapPageContainer'),
  loading: LoadingComponent
});
const AsyncLoginContainer = Loadable({
  loader: () => import('./pages/Login/LoginContainer'),
  loading: LoadingComponent
});
const AsyncTokenRedirectComponent = Loadable({
  loader: () => import('./pages/TokenRedirect/TokenRedirectComponent'),
  loading: LoadingComponent
});
const AsyncUsersContainer = Loadable({
  loader: () => import('./pages/Accounts/Users/UsersContainer'),
  loading: LoadingComponent
});
const AsyncGroupsContainer = Loadable({
  loader: () => import('./pages/Accounts/Groups/GroupsContainer'),
  loading: LoadingComponent
});
const AsyncLegalContainer = Loadable({
  loader: () => import('./pages/Legal/LegalContainer'),
  loading: LoadingComponent
});

const AsyncPrivacyContainer = Loadable({
  loader: () => import('./pages/Privacy/PrivacyContainer'),
  loading: LoadingComponent
});

const AppLayoutComponent = ({ match: { path }, favicon = null }, { t }) => (
  <React.Fragment>
    <Helmet>
      <title>{t('Novus Health Dashboard')}</title>
      <link
        id="favicon_helmet_link"
        rel="shortcut icon"
        href={favicon}
        data-react-helmet="true"
        type="image/x-icon"
      />
    </Helmet>
    <AppContainer>
      <Route component={NavigationContainer} />
      <AppRow>
        <Route component={SideMenuContainer} />
        <Col>
          <Switch>
            <Route
              exact
              path={`${path}/login`}
              component={withAnalytics(AsyncLoginContainer)}
            />
            <PrivateRoute
              exact
              path={`${path}/home`}
              component={withAnalytics(AsyncHomeContainer)}
            />
            <PrivateRoute
              exact
              path={`${path}/platform-usage`}
              component={withAnalytics(AsyncPlatformUsageContainer)}
            />
            <PrivateRoute
              exact
              path={`${path}/shaw-statistics`}
              component={withAnalytics(AsyncSHAWContainer)}
            />
            <PrivateRoute
              exact
              path={`${path}/data-reports`}
              component={withAnalytics(AsyncCallCenterContainer)}
            />
            <Redirect
              exact
              from={`${path}/accounts`}
              to={`${path}/accounts/users`}
            />
            <PrivateAdminRoute
              exact
              path={`${path}/accounts/users`}
              component={withAnalytics(AsyncUsersContainer)}
            />
            <PrivateAdminRoute
              exact
              path={`${path}/accounts/groups`}
              component={withAnalytics(AsyncGroupsContainer)}
            />
            <Redirect
              exact
              from={`${path}/communication`}
              to={`${path}/communication/messages`}
            />
            <PrivateRoute
              exact
              path={`${path}/communication/messages`}
              component={withAnalytics(AsyncMessagesContainer)}
            />
            <PrivateRoute
              exact
              path={`${path}/communication/messages/compose`}
              component={withAnalytics(AsyncComposeMessageContainer)}
            />
            <Route
              exact
              path={`${path}/sso/token/:token/:redirect/:redirect2?`}
              component={AsyncTokenRedirectComponent}
            />
            <Redirect
              exact
              from={`${path}/travel-security`}
              to={`${path}/travel-security/map`}
            />
            <PrivateRoute
              exact
              path={`${path}/travel-security/alerts`}
              component={withAnalytics(AsyncAlertContainer)}
            />
            <PrivateRoute
              exact
              path={`${path}/travel-security/map`}
              component={withAnalytics(AsyncMapContainer)}
            />
            <Route
              exact
              path={`${path}/legal`}
              component={withAnalytics(AsyncLegalContainer)}
            />
            <Route
              exact
              path={`${path}/privacy`}
              component={withAnalytics(AsyncPrivacyContainer)}
            />
            <Redirect to={`${path}/home`} />
          </Switch>
          <Route component={FooterContainer} />
        </Col>
        <OnboardingTour />
      </AppRow>
      <NotificationContainer />
    </AppContainer>
  </React.Fragment>
);

AppLayoutComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default AppLayoutComponent;



// WEBPACK FOOTER //
// ./src/components/AppLayoutComponent.js